import { render, staticRenderFns } from "./bulletincom.vue?vue&type=template&id=02518628&scoped=true"
import script from "./bulletincom.vue?vue&type=script&lang=js"
export * from "./bulletincom.vue?vue&type=script&lang=js"
import style0 from "./bulletincom.vue?vue&type=style&index=0&id=02518628&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02518628",
  null
  
)

export default component.exports